

export class ApplicationModuleStatusInput implements IApplicationModuleStatusInput {
    /** The auto-generated id of the application module master */
    applicationModuleId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IApplicationModuleStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationModuleId = _data["applicationModuleId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ApplicationModuleStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationModuleStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationModuleId"] = this.applicationModuleId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IApplicationModuleStatusInput {
    /** The auto-generated id of the application module master */
    applicationModuleId: number;
    /** The updated status */
    status: number;
}

